import {Box} from "@mui/material";
import {FolioStatus} from "crqlar-react-common/dist/models/billing/folio.model";
import React from "react";
import {useTranslation} from "react-i18next";
import {ElementChip} from "./base/ElementChip";
import {StatusDot} from "./base/StatusDot";
import {getFolioStatusColor} from "./colors";

/** The statuses as staff read them: an OPEN folio is "Finalized" (existing translation keys). */
export const FOLIO_STATUS_LABEL_KEYS: Record<FolioStatus, string> = {
    [FolioStatus.DRAFT]: 'Draft',
    [FolioStatus.OPEN]: 'Finalized',
    [FolioStatus.PAID]: 'Folio status PAID',
    [FolioStatus.PREAUTHORIZED]: 'Folio status PREAUTHORIZED',
    [FolioStatus.RELEASED]: 'Folio status RELEASED',
    [FolioStatus.REFUNDED]: 'Folio status REFUNDED',
    [FolioStatus.VOID]: 'Folio status VOID',
    [FolioStatus.UNCOLLECTABLE]: 'Folio status UNCOLLECTABLE',
};

interface FolioStatusElementProps {
    status: FolioStatus | undefined;
    asPrint?: boolean;
}

/** A folio's status in a list or a header, like the reservation's and the signing's. */
export function FolioStatusElement({status, asPrint = false}: FolioStatusElementProps) {
    const {t} = useTranslation();

    if (!status) {
        return null;
    }

    const text = t(FOLIO_STATUS_LABEL_KEYS[status] ?? status);

    if (asPrint) {
        return <>{text}</>;
    }

    return (
        <Box sx={{display: "inline-flex", maxWidth: "100%"}}>
            <ElementChip text={text} startIcon={<StatusDot color={getFolioStatusColor(status)}/>}/>
        </Box>
    );
}
